const MOBILE_UA = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;

export const isMobileDevice: boolean =
  typeof window !== 'undefined' &&
  (window.innerWidth <= 768 || MOBILE_UA.test(navigator.userAgent));
